import React from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import Grid from '../Grid';
import Button from '../Button';
import Image from '../Image';
import PrintIcon from './icon-print.png';
import EventsExport from '../../containers/EventsExport';
import './styles.css';
import SubscriptionActive from '../SubscriptionActive';
import SubscriptionInActive from '../SubscriptionInactive';
import { REP_VISITS_SUBSCRIPTION } from '../../containers/Authorization/constants';

export const PrintButton = () => (
  <Button size="mini" data-cy="repvisits-calendar-print-button" styleName="noPrint printButton" onClick={() => window.print()}>
    <Image src={PrintIcon} centered alt="Print" />
  </Button>
);

export const DisabledPrintButton = () => (
  <Button size="mini" styleName="printButton" data-cy="repvisits-calendar-print-button-disabled" disabled>
    <Image src={PrintIcon} centered alt="Print" />
  </Button>
);

export const AgendaViewButton = ({ onView, view }) => (
  <Button
    onClick={() => { onView('agenda'); }}
    {...(view === 'agenda' ? { color: 'pink' } : {})}
    basic={view !== 'agenda'}
    title="Agenda"
    content="Agenda"
    styleName="view-type-control agenda"
    data-cy="calendar-agenda-button"
  />
);

AgendaViewButton.propTypes = {
  view: PropTypes.string,
  onView: PropTypes.func,
};

const Toolbar = ({ view, onNavigate, onView, label }) => (
  <Grid verticalAlign="middle" padded>
    <Grid.Row>
      {view !== 'agenda' && (
      <Grid.Column width={3} styleName="month-year-container">
        <Header as="h2" size="medium" data-cy="repvisits-big-calendar-month-year-title" styleName="month-year">
          {label}
        </Header>
      </Grid.Column>
      )}
      {view !== 'agenda' ? (
        <Grid.Column width={3}>
          <Button.Group size="tiny" styleName="view-navigation noPrint">
            <Button
              styleName="backwards"
              onClick={() => {
                onNavigate('PREV');
              }}
              title="Backwards"
              data-cy="repvisits-big-calendar-date-backwards-button"
              icon="caret left"
            />
            <Button
              styleName="today"
              onClick={() => {
                onNavigate('TODAY');
              }}
              title="Today"
              data-cy="repvisits-big-calendar-date-today-button"
              content="Today"
            />
            <Button
              styleName="forwards"
              onClick={() => {
                onNavigate('NEXT');
              }}
              title="Forwards"
              data-cy="repvisits-big-calendar-date-forwards-button"
              icon="caret right"
            />
          </Button.Group>
        </Grid.Column>
      ):
        <Grid.Column width={6} />}
      <Grid.Column width={2}>
        <EventsExport styleName="noPrint" />
      </Grid.Column>
      <Grid.Column width={2}>
        <SubscriptionActive anyOf={REP_VISITS_SUBSCRIPTION}>
          <PrintButton />
        </SubscriptionActive>
        <SubscriptionInActive allOf={REP_VISITS_SUBSCRIPTION}>
          <DisabledPrintButton />
        </SubscriptionInActive>
      </Grid.Column>
      <Grid.Column verticalAlign="middle" width={6} textAlign="right">
        <Button.Group size="medium" styleName="noPrint">
          <Button
            onClick={() => { onView('day'); }}
            {...(view === 'day' ? { color: 'pink' } : {})}
            basic={view !== 'day'}
            title="Day"
            data-cy="repvisits-calendar-day-view-button"
            content="Day"
            styleName="view-type-control day"
          />
          <Button
            onClick={() => { onView('week'); }}
            {...(view === 'week' ? { color: 'pink' } : {})}
            basic={view !== 'week'}
            title="Week"
            data-cy="repvisits-calendar-week-view-button"
            content="Week"
            styleName="view-type-control week"
          />
          <Button
            onClick={() => { onView('month'); }}
            {...(view === 'month' ? { color: 'pink' } : {})}
            basic={view !== 'month'}
            data-cy="repvisits-calendar-month-view-button"
            title="Month"
            content="Month"
            styleName="view-type-control month"
          />
          <AgendaViewButton
            onView={onView}
            view={view}
          />
        </Button.Group>
      </Grid.Column>
    </Grid.Row>
  </Grid>
);

Toolbar.propTypes = {
  view: PropTypes.string,
  onNavigate: PropTypes.func,
  onView: PropTypes.func,
  label: PropTypes.string,
};

export default Toolbar;
